export enum APICallContextEnum {
  DASHBOARD = 'DASHBOARD',
  DASHBOARD_EDIT = 'DASHBOARD_EDIT',
  FINDING_LIST = 'FINDING_LIST',
  BLANK = 'BLANK',
}
